import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { PHBHPFeaturePackageConfigurationComponent } from './ph-bhp-feature-package-configuration.component';
import { PhBhpConfigureDepartmentComponent } from './ph-bhp-configure-department/ph-bhp-configure-department.component';
import { PhBhpConfigureCountryComponent } from './ph-bhp-configure-country/ph-bhp-configure-country.component';
import { PhBhpConfigureImageLibraryComponent } from './ph-bhp-configure-image-library/ph-bhp-configure-image-library.component';

import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ConfigureComponent } from './configure/configure.component';
import {NgxMaskModule} from 'ngx-mask';
// tslint:disable-next-line:max-line-length
// tslint:disable-next-line:max-line-length
import { PhBhpConfigureProfessionalCategoryComponent } from './ph-bhp-configure-professional-category/ph-bhp-configure-professional-category.component';
import { PhBhpConfigureSubCategoryComponent } from './ph-bhp-configure-sub-category/ph-bhp-configure-sub-category.component';
import { PhBhpConfigureWardComponent } from './ph-bhp-configure-ward/ph-bhp-configure-ward.component';
import { PhBhpConfigureCommentsComponent } from './ph-bhp-configure-comments/ph-bhp-configure-comments.component';
import { PhBhpConfigureCheckCommentsComponent } from './ph-bhp-configure-check-comments/ph-bhp-configure-check-comments.component';
import { PhBhpConfigureTurorialComponent } from './ph-bhp-configure-turorial/ph-bhp-configure-turorial.component';
import { PhBhpConfigureTurorialmanagementComponent } from './ph-bhp-configure-turorialmanagement/ph-bhp-configure-turorialmanagement.component';
import { PhBhpConfigureImageInstitutionComponent } from './ph-bhp-configure-image-institution/ph-bhp-configure-image-institution.component';

import { PhBhpConfigureGeneralComponent } from './ph-bhp-configure-general/ph-bhp-configure-general.component';
import { PhBhpConfigureCountrySettingsComponent } from './ph-bhp-configure-country-settings/ph-bhp-configure-country-settings.component';
import { PhBhpObserveManageQuotaComponent } from '../ObserveObservation/ph-bhp-observe-manage-quota/ph-bhp-observe-manage-quota.component';
import { PhBhpConfigureNewQuotaComponent } from '../ObserveObservation/ph-bhp-observe-new-quota/ph-bhp-observe-new-quota.component';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/public_api';

// Angular Library Imports
import { MatChipsModule } from '@angular/material/chips';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { MatRadioModule } from "@angular/material/radio";
import { MatListModule } from "@angular/material/list";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { ClientLibModule } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { PhBhpConfigureCheckPredefinedCommentsComponent } from './ph-bhp-configure-check-predefined-comments/ph-bhp-configure-check-predefined-comments.component';

@NgModule({
  declarations: [
    ConfigureComponent,
    PHBHPFeaturePackageConfigurationComponent,
    PhBhpConfigureDepartmentComponent,
    PhBhpConfigureCountryComponent,
    PhBhpConfigureImageLibraryComponent,
    PhBhpConfigureSubCategoryComponent,
    PhBhpConfigureProfessionalCategoryComponent,
    PhBhpConfigureWardComponent,
    PhBhpConfigureCommentsComponent,
    PhBhpConfigureCheckCommentsComponent,
    PhBhpConfigureTurorialComponent,
    PhBhpConfigureTurorialmanagementComponent,
    PhBhpConfigureImageInstitutionComponent,
    PhBhpConfigureGeneralComponent,
    PhBhpConfigureCountrySettingsComponent,
    PhBhpObserveManageQuotaComponent,
    PhBhpConfigureNewQuotaComponent,
    PhBhpConfigureCheckPredefinedCommentsComponent
  ],
  imports: [
    PHBHPLayoutPackageModule,
    PHBHPLocalizePackageModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    PhBhpUiModule,
    MatChipsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatIconModule,
    MatSelectModule,
    MatRadioModule,
    MatListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    ClientLibModule,
    PhBhpFeatureComponentsModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
  ]
})
export class PHBHPFeaturePackageConfigurationModule { }
